import React, { useState } from "react";
import "./style.css";
import Modal from "./Modal";

import img7 from "./behance/pj3/394287608_352872233943941_1630243947226967977_n.webp";
import img8 from "./behance/pj3/394587668_1503522057093584_2985027626011819377_n.webp";
import img9 from "./behance/pj3/394608131_663577339204740_6927187173711715285_n.webp";
import img10 from "./behance/pj3/394639181_1567372327404210_6328343983485827328_n.webp";
import img11 from "./behance/pj3/394656116_744629137475438_3349913102973964147_n.webp";
import img12 from "./behance/pj3/394931064_826545815894847_489480626970726291_n.webp";
import img13 from "./behance/pj2/1.webp";
import img14 from "./behance/pj2/1 (1).webp";
import img15 from "./behance/pj2/1 (2).webp";
import img16 from "./behance/pj2/1 (3).webp";
import img17 from "./behance/pj2/1 (4).webp";
import img18 from "./behance/pj2/1 (5).webp";

export default function Gallery() {
  let imgg1 =
    "https://firebasestorage.googleapis.com/v0/b/mapicha-eb4ac.appspot.com/o/f781a8183583041.65425a8d6b581.jpg?alt=media&token=e2b0ce43-786a-4e71-b4a5-cde975af4d15";
  let imgg2 =
    "https://firebasestorage.googleapis.com/v0/b/mapicha-eb4ac.appspot.com/o/d181ed183583041.6542979d7b1c2.jpg?alt=media&token=7c673b49-e0c5-4ce0-b70c-51e98f9df5e3";
  let imgg3 =
    "https://firebasestorage.googleapis.com/v0/b/mapicha-eb4ac.appspot.com/o/0b48ec183583041.65425a8d6f925.jpg?alt=media&token=d5d40113-0ae5-4bf7-935b-cd9cd9db1301";
  let imgg4 =
    "https://firebasestorage.googleapis.com/v0/b/mapicha-eb4ac.appspot.com/o/1.jpg?alt=media&token=4a6e5b2a-b3d4-42d8-ac62-b4e331005c4b";
  let imgg5 =
    "https://firebasestorage.googleapis.com/v0/b/mapicha-eb4ac.appspot.com/o/2.jpg?alt=media&token=6cfdaf3e-c297-4be6-b849-9de39398400e";
  let imgg6 =
    "https://firebasestorage.googleapis.com/v0/b/mapicha-eb4ac.appspot.com/o/3.jpg?alt=media&token=80c6ad9c-f92d-45b6-8522-b9d79f2f16fd";
  let imgg7 =
    "https://firebasestorage.googleapis.com/v0/b/mapicha-eb4ac.appspot.com/o/1%20(1).webp?alt=media&token=018a46b3-72f7-4ab2-9ddd-81c97881c86d";
  let imgg8 =
    "https://firebasestorage.googleapis.com/v0/b/mapicha-eb4ac.appspot.com/o/1%20(2).webp?alt=media&token=9d671f79-d885-4339-8ebf-349b20a3f95f";
  let imgg9 =
    "https://firebasestorage.googleapis.com/v0/b/mapicha-eb4ac.appspot.com/o/1%20(3).webp?alt=media&token=2483e4b8-be33-4a26-924c-e59b30e0d6c7";
  let imgg10 =
    "https://firebasestorage.googleapis.com/v0/b/mapicha-eb4ac.appspot.com/o/1%20(4).webp?alt=media&token=e5d8356a-fee1-48c5-89aa-d362b47b8666";
  let imgg11 =
    "https://firebasestorage.googleapis.com/v0/b/mapicha-eb4ac.appspot.com/o/1%20(5).webp?alt=media&token=e611577d-fd32-4939-b649-23547a3d20e7";
  let imgg14 = "";
  let imgg15 = "";
  let imgg16 = "";
  let imgg17 = "";
  let imgg18 = "";

  const [isOpen, setIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const openDialog = (imgSrc) => {
    setSelectedImage(imgSrc);
    setIsOpen(true);
  };

  return (
    <div>
      <section
        className="gallery min-vh-100"
        style={{
          background:
            "linear-gradient(245.59deg, #4d9559 0%, #38703d 28.53%, #133917 55.53%)",
        }}
      >
        <div className="container-fluid mb-4">
          <h1 className="text-center  display-3 fw-bold">
            <span className="uno-theme-text">Graphic</span>{" "}
            <span className="theme-text">Design Works</span>
          </h1>
          <hr className="mx-auto mb-5 w-25" />

          <div className="row gy-4 row-cols-1 row-cols-sm-2 row-cols-md-3">
            <div className="col">
              <img
                src={imgg1}
                className="gallery-item"
                alt="gallery"
                onClick={() => openDialog(imgg1)}
              />
            </div>
            <div className="col">
              <img
                src={imgg2}
                className="gallery-item"
                alt="gallery"
                onClick={() => openDialog(imgg2)}
              />
            </div>
            <div className="col">
              <img
                src={imgg3}
                className="gallery-item"
                alt="gallery"
                onClick={() => openDialog(imgg3)}
              />
            </div>
            <div className="col">
              <img
                src={imgg4}
                className="gallery-item"
                alt="gallery"
                onClick={() => openDialog(imgg4)}
              />
            </div>
            <div className="col">
              <img
                src={imgg5}
                className="gallery-item"
                alt="gallery"
                onClick={() => openDialog(imgg5)}
              />
            </div>
            <div className="col">
              <img
                src={imgg6}
                className="gallery-item"
                alt="gallery"
                onClick={() => openDialog(imgg6)}
              />
            </div>
          </div>
        </div>
        <div className="container-fluid mb-4">
          <div className="row gy-4 row-cols-1 row-cols-sm-2 row-cols-md-3">
            <div className="col">
              <img
                src={img13}
                className="gallery-item"
                alt="gallery"
                onClick={() => openDialog(img13)}
              />
            </div>
            <div className="col">
              <img
                src={img14}
                className="gallery-item"
                alt="gallery"
                onClick={() => openDialog(img14)}
              />
            </div>
            <div className="col">
              <img
                src={img15}
                className="gallery-item"
                alt="gallery"
                onClick={() => openDialog(img15)}
              />
            </div>
            <div className="col">
              <img
                src={img16}
                className="gallery-item"
                alt="gallery"
                onClick={() => openDialog(img16)}
              />
            </div>
            <div className="col">
              <img
                src={img17}
                className="gallery-item"
                alt="gallery"
                onClick={() => openDialog(img17)}
              />
            </div>
            <div className="col">
              <img
                src={img18}
                className="gallery-item"
                alt="gallery"
                onClick={() => openDialog(img18)}
              />
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row gy-4 row-cols-1 row-cols-sm-2 row-cols-md-3">
            <div className="col">
              <img
                src={imgg7}
                className="gallery-item"
                alt="gallery"
                onClick={() => openDialog(imgg7)}
              />
            </div>
            <div className="col">
              <img
                src={imgg8}
                className="gallery-item"
                alt="gallery"
                onClick={() => openDialog(imgg8)}
              />
            </div>
            <div className="col">
              <img
                src={imgg9}
                className="gallery-item"
                alt="gallery"
                onClick={() => openDialog(imgg9)}
              />
            </div>
            <div className="col">
              <img
                src={imgg10}
                className="gallery-item"
                alt="gallery"
                onClick={() => openDialog(imgg10)}
              />
            </div>
            <div className="col">
              <img
                src={imgg11}
                className="gallery-item"
                alt="gallery"
                onClick={() => openDialog(imgg11)}
              />
            </div>
            <div className="col">
              <img
                src={img12}
                className="gallery-item"
                alt="gallery"
                onClick={() => openDialog(img12)}
              />
            </div>
          </div>
        </div>
      </section>

      {isOpen && (
        <Modal open={isOpen}>
          <div
            id="portal"
            style={{
              position: "fixed",
              top: 0,
              bottom: 0,
              right: 0,
              left: 0,
              paddingTop: "20px",
              backgroundColor: "rgba(0,0,0,0.8)",
              zIndex: 11,
            }}
          >
            {selectedImage && (
              <div className="image-container">
                <div className="img-wrapper">
                  {" "}
                  <h1 className="x-mark" onClick={() => setIsOpen(!isOpen)}>
                    X
                  </h1>
                  <img
                    className="img-to-be-fluid"
                    onClick={() => setIsOpen(!isOpen)}
                    src={selectedImage}
                    alt="Selected"
                  />{" "}
                </div>
              </div>
            )}
          </div>
        </Modal>
      )}
    </div>
  );
}
